module.exports = __webpack_public_path__ + "img/account.5700c041.png";